import { useMemo } from "react";
import { DocumentEntityType, DocumentType } from "../../../api/caseDocuments";
import ReportDocuments from "../../documentManagement/components/ReportDocuments";

interface InvestigationDocumentsProps {
    caseId: string;
}   

const InvestigationDocuments = ({ caseId }: InvestigationDocumentsProps) => {
  const entityType = useMemo(() => DocumentEntityType.CASE, []);

  const renderHeader = () => {
    return (
      <div className="w-full h-[52px] flex items-center justify-between gap-4 px-4 border border-[#E5E5E5] rounded-t-[14px] bg-[#F9FAFB]">
        <span className="font-sans font-medium text-sm leading-5 text-[#0A0A0A]">
          Documents
        </span>
      </div>
    );
  };

  const renderBody = () => {
    return (
      <div className="w-full border-x border-b border-[#E5E5E5] rounded-b-[14px] p-4 flex flex-col gap-4">
        <div className="w-full flex flex-col gap-3">
          <ReportDocuments
            document_type={DocumentType.INVESTIGATION_REPORT}
            entityType={entityType}
            entityId={caseId}
            action="view"
            hideUploadButton={true}
            title="Investigation Report"
          />
        </div>

        <div className="h-px w-full bg-[#E5E5E5]" />

        <div className="w-full flex flex-col gap-3">
          <ReportDocuments
            document_type={DocumentType.INVESTIGATION_SUPPORTING}
            entityType={entityType}
            entityId={caseId}
            action="view"
            hideUploadButton={true}
            title="Supporting Documents"
          />
        </div>
      </div>
    );
  };

  return (
    <div className="mx-6 mt-4">
      {renderHeader()}
      {renderBody()}
    </div>
  );
};

export default InvestigationDocuments;